import React from "react";
import * as c from "./blogPostGrid.module.scss";
import classNames from "classnames";
import { BlogPostCard } from "@components/blog/blogPostCard";
import { BlogAd } from "@components/blog/blogAd";

const BlogPostGrid = ({ className, items = [], size = "sm" }) => {
  // TODO: Probably more intuitive to pass items as children and not force size
  return (
    <div className={classNames(className, c.container, c[size])}>
      {items.map((item) => (
        <React.Fragment key={`item-${item.id}`}>
          {item.__typename === "ContentfulBlogPost" && <BlogPostCard className={c.article} post={item} size={size} />}
          {item.__typename === "ContentfulLandingPageSection2Column1Image" && <BlogAd className={c.ad} {...item} />}
        </React.Fragment>
      ))}
    </div>
  );
};

export { BlogPostGrid };
